/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { SvenskdamStandaloneShowsSlider as ResolvedStandaloneShowsSlider } from 'sites/svenskdam/components/standalone/ShowsSlider';

export const ShowsSlider: typeof ResolvedStandaloneShowsSlider = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneShowsSlider {...props} />
        </ErrorBoundary>
    );
});

export type ShowsSliderProps = PropsFromComponent<typeof ShowsSlider>;

/** @deprecated Use slot architecture instead */
export const ShowsSliderWith = (extras: DynamicStandaloneExtras): typeof ShowsSlider => {
    return function ShowsSlider(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ShowsSlider');
        return <ResolvedStandaloneShowsSlider {...mergeProps({ options: { theme } }, props)} />;
    }
}